import { AxiosInstance } from 'axios';

import { transformToCamelCase } from '$app-web/utils';

declare module 'axios' {
    export interface AxiosRequestConfig {
        skipCamelCase?: boolean;
    }
}

export function transformResponseToCamelCase(axios: AxiosInstance): void {
    axios.interceptors.response.use((response) => {
        if (response.config?.skipCamelCase) return response;

        const { data } = response;
        const transformedData = transformToCamelCase(data);

        return { ...response, data: transformedData };
    });
}
